<template>
    <el-drawer
        title="管理置顶演出"
        :visible="visible"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="600px"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"

            >
                <el-row :gutter="40">
                    <el-col :xs="24" :sm="24" :xl="24">
                        <el-form-item prop="activityId" label="演出ID:">
                            <el-input v-model="formData.activityId" @input="onInput" placeholder="请填写演出ID" />
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :xl="24">
                        <el-form-item prop="city" label="置顶城市:">
                            <city-select :value.sync="formData.city" :value-options="cityOptions" :multiple="cityOptions.length === 0"></city-select>
                            <small class="MT10 red">
                                <span class="el-icon-warning"></span>  
                                  如果需要在多个城市置顶，系统会为每个城市创建单独的置顶记录。如果同时设置了省份和省份下的某个城市展示
								  ，则全省展示。如果同时设置了省份和省份下的某个城市不展示，则全省不展示。
                            </small>
                        </el-form-item>
                    </el-col>
					<el-col :xs="24" :sm="24" :xl="24">
						<el-form-item prop="time1" label="展示时间段1:">
						    <div class="form-flex">
						        <el-date-picker v-model="time1" type="datetimerange" range-separator="至"
						            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
						            start-placeholder="开始日期" end-placeholder="结束日期"
						            unlink-panels size="medium">
						        </el-date-picker>
						    </div>						    
						</el-form-item>						
						<el-form-item prop="time2" label="展示时间段2:">
						    <div class="form-flex">
						        <el-date-picker v-model="time2" type="datetimerange" range-separator="至"
						            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
						            start-placeholder="开始日期" end-placeholder="结束日期" unlink-panels size="medium">
						        </el-date-picker>
						    </div>
						</el-form-item>						
						<el-form-item prop="time3" label="展示时间段3:">
						    <div class="form-flex">
						        <el-date-picker v-model="time3" type="datetimerange" range-separator="至"
						            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
						            start-placeholder="开始日期" end-placeholder="结束日期" unlink-panels size="medium">
						        </el-date-picker>
						    </div>
						    <small class="MT10 red">
						        <span class="el-icon-warning"></span>最晚的展示时间段到期后，会自动删除置顶演出
						    </small>
						</el-form-item>
					</el-col>
                </el-row>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确认</el-button>
        </div>
    </el-drawer>
</template>

<script>
import CitySelect from '@/components/CitySelect';

export default {
    components: {
		CitySelect
    },
    props: {
        detail: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    watch: {
           detail: {
               immediate: true,
               handler(detail) {
				   
                   if(detail.id) {
                       this.formData.activityId = detail.activityId;
                       this.formData.id = detail.id;
                       this.formData.city = detail.cityId;
					   this.formData.autoDeleteTime = detail.autoDeleteTime;
                       this.cityOptions = [{label: detail.cityName, value: detail.cityId}];					  
					   this.time1 = [detail.firstStartDate || '', detail.firstEndDate || ''];
					   this.time2 = [detail.secondStartDate || '', detail.secondEndDate || ''];
					   this.time3 = [detail.startDate || '', detail.autoDeleteTime || ''];
					   
                   }
               }
           },
       },
    data(){
        return{
            btnLoading:false,
			time1: [],
			time2: [],
			time3: [],
            cityOptions: [],
			sellArea:[],
			cityList: [],
            formData: {
                city: [],
				province:[],
                activityId: '',
				settingType:'',
                id: ''				
            },
			pickerOptions:{
			    disabledDate(time) {
			        return time.getTime() < Date.now();
			    },
			},
            rules: {
                city: [{ required: true, message: "请选择城市" }],
                activityId: [{ required: true, message: "请填写演出ID" }]
				
            }
        }
    },
	async created() {
		
	},
    methods:{
        close() {
           this.$emit('update:visible', false);
        },
        onInput (value) {
            if (!/^[0-9]+$/.test(value)) this.formData.activityId = '';
        },
		
        async submitForm(){
            this.$refs["formData"].validate(async (valid) => {
                if (valid) {
                    const form = JSON.parse(JSON.stringify(this.formData));
                    
					const city = JSON.parse(form.city)
					form.city=[]
					form.city.push(city)
					
					form.firstStartDate = this.time1 && this.time1 [0] || '';
					form.firstEndDate = this.time1 && this.time1[1] || '';
					form.secondStartDate = this.time2 && this.time2[0] || '';
					form.secondEndDate = this.time2 && this.time2[1] || '';
					form.startDate = this.time3 && this.time3[0] || '';
					form.autoDeleteTime = this.time3 && this.time3[1] || '';
					
                    const response = await this.$request({
                        url: '/activityTop/edit',
                        method:'post',
                        data: form
                    })
                    const {msg, state} = response.data;
                    if (state != 1) return this.$message.error(msg);
                    this.$message.success('操作成功');
                    this.$emit('update:visible', false);
                    this.$emit('onRefresh', true);
                }
            });
            
        }
    }
}
</script>
<style lang="scss" scoped>
	.red{
		color:#F56C6C
	}
</style>